import React from 'react';
import { Box, Typography } from '@mui/material';
import BottomSheet from '../../../../Components/Ui/BottomSheet';
import { Button } from '../../../../Components/MUIs';

export default function WitnessWorkEndGuideBottomSheet({
  unsignedWorkTypes = [],
  onStartSign,
}) {
  return (
    <BottomSheet
      isHeaderChildren
      headerText=""
      headerChildren={
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 'bold',
            lineHeight: 1.4,
          }}
        >
          작업종료 전 <span style={{ color: '#57B84D' }}>입회 서명</span>이
          필요합니다
        </Typography>
      }
    >
      <Box sx={{ px: 1, pb: 1 }}>
        <Typography sx={{ color: '#918A8A', fontSize: '14px', mb: 2 }}>
          작업종료를 위해 모든 작업종류별 입회 서명을 완료해 주세요.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            mb: 2,
          }}
        >
          {unsignedWorkTypes.map((item) => (
            <Box
              key={item.workItemId}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: '12px',
                border: '1px solid #fbbf24',
                bgcolor: '#fffbeb',
                px: 2,
                py: 1.5,
              }}
            >
              <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>
                {item.workTypeNm}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 700,
                  color: '#d97706',
                }}
              >
                서명 필요
              </Typography>
            </Box>
          ))}
        </Box>

        <Button
          name="서명 시작"
          sx={{
            width: '100%',
            height: 44,
            borderRadius: '8px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={onStartSign}
        />
      </Box>
    </BottomSheet>
  );
}
